


/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// UPDATEPLANPUT
// UPDATEPLANPUT
const UPDATEPLANPUT= createAsyncThunk(
  "updatePlanPut/updatePlanPut",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updatePlanPutSlice = createSlice({
  name: "updatePlanPutSlice",
  initialState: {
    updatePlanPut: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdatePlanPut: (state) => {
        state.updatePlanPut.loading = false
        state.updatePlanPut.error = false
        state.updatePlanPut.data = []
        state.updatePlanPut.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPDATEPLANPUT.fulfilled, (state, action) => {
      state.updatePlanPut = {
        ...state.updatePlanPut,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEPLANPUT.pending, (state, action) => {
      state.updatePlanPut = {
        ...state.updatePlanPut,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEPLANPUT.rejected, (state, action) => {
      state.updatePlanPut = {
        ...state.updatePlanPut,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updatePlanPutAction = {
    UPDATEPLANPUT,
};

export { updatePlanPutAction };
export default updatePlanPutSlice.reducer;
export const {setInitialStateOfupdatePlanPut} = updatePlanPutSlice.actions